// @generated by protoc-gen-es v2.9.0 with parameter "target=ts"
// @generated from file squareup/franklin/cash_instrument_type.proto (package squareup.franklin, syntax proto2)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";
import { file_squareup_objc_objc } from "../objc/objc_pb";

/**
 * Describes the file squareup/franklin/cash_instrument_type.proto.
 */
export const file_squareup_franklin_cash_instrument_type: GenFile = /*@__PURE__*/
  fileDesc("CixzcXVhcmV1cC9mcmFua2xpbi9jYXNoX2luc3RydW1lbnRfdHlwZS5wcm90bxIRc3F1YXJldXAuZnJhbmtsaW4qsgEKEkNhc2hJbnN0cnVtZW50VHlwZRIOCgpERUJJVF9DQVJEEAESEAoMQkFOS19BQ0NPVU5UEAISDwoLQ1JFRElUX0NBUkQQAxIQCgxDQVNIX0JBTEFOQ0UQBBISCg5MSU5FX09GX0NSRURJVBAFEg0KCUFQUExFX1BBWRAHEg4KCkdPT0dMRV9QQVkQCBIHCgNFQlQQCRIVChFTVEFCTEVDT0lOX1dBTExFVBAKIgQIBhAGQnIKIGNvbS5zcXVhcmV1cC5wcm90b3MuZnJhbmtsaW4uYXBpQhhDYXNoSW5zdHJ1bWVudFR5cGVQcm90b3NaJnNxdWFyZXVwX2ZyYW5rbGluX2Nhc2hfaW5zdHJ1bWVudF90eXBlwpsDCkNDQVBJUHJvdG8", [file_squareup_objc_objc]);

/**
 * * CashInstrumentType represents the types of instruments that can be used within Cash. 
 *
 * @generated from enum squareup.franklin.CashInstrumentType
 */
export enum CashInstrumentType {
  /**
   * @generated from enum value: DEBIT_CARD = 1;
   */
  DEBIT_CARD = 1,

  /**
   * @generated from enum value: BANK_ACCOUNT = 2;
   */
  BANK_ACCOUNT = 2,

  /**
   * @generated from enum value: CREDIT_CARD = 3;
   */
  CREDIT_CARD = 3,

  /**
   * @generated from enum value: CASH_BALANCE = 4;
   */
  CASH_BALANCE = 4,

  /**
   * @generated from enum value: LINE_OF_CREDIT = 5;
   */
  LINE_OF_CREDIT = 5,

  /**
   * @generated from enum value: APPLE_PAY = 7;
   */
  APPLE_PAY = 7,

  /**
   * @generated from enum value: GOOGLE_PAY = 8;
   */
  GOOGLE_PAY = 8,

  /**
   * @generated from enum value: EBT = 9;
   */
  EBT = 9,

  /**
   * @generated from enum value: STABLECOIN_WALLET = 10;
   */
  STABLECOIN_WALLET = 10,
}

/**
 * Describes the enum squareup.franklin.CashInstrumentType.
 */
export const CashInstrumentTypeSchema: GenEnum<CashInstrumentType> = /*@__PURE__*/
  enumDesc(file_squareup_franklin_cash_instrument_type, 0);

